import workflows from './workflows';
import statuses from './statuses';

export default function* () {
    yield* [
        ...workflows,
        ...statuses,
    ];
}
